__turbopack_context__.v({
  "className": "inter_3985030d-module___p3_ea__className",
  "variable": "inter_3985030d-module___p3_ea__variable",
});
